function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { CoreVideoInternal } from '../../../../core-video-internal';
import { sdkLogger } from '../../../../logger';
import { NielsenContentType } from '../../nielsen-addon/nielson-api-client/nielsen-cloud-api-client';
import { NielsenSdkPlayheadEventTypes } from './nielsen-sdk.enums';
export { NielsenSdkPlayheadEventTypes } from './nielsen-sdk.enums';
var Logger = sdkLogger.withContext('NielsenSdkApiClient');
var NIELSEN_SDK_DEBUG_MODE = 'debug';
export var NielsenSdkContentMetadataPayload = {
    type: NielsenContentType.Content,
    adModel: '1'
};
export var NielsenSdkApiClient = /*#__PURE__*/ function() {
    "use strict";
    function NielsenSdkApiClient(config, metaAdapter) {
        var _this = this;
        _class_call_check(this, NielsenSdkApiClient);
        _define_property(this, "config", void 0);
        _define_property(this, "metaAdapter", void 0);
        _define_property(this, "nielsenSdkInstance", void 0);
        // noop
        _define_property(this, "initializeSdk", void 0);
        this.config = config;
        this.metaAdapter = metaAdapter;
        this.initializeSdk = function() {
            var options = {
                optout: 'false'
            };
            if (!_this.config.enableProduction) {
                options.nol_sdkDebug = NIELSEN_SDK_DEBUG_MODE;
            }
            var _this_config_sdkAppId;
            var appId = (_this_config_sdkAppId = _this.config.sdkAppId) !== null && _this_config_sdkAppId !== void 0 ? _this_config_sdkAppId : _this.metaAdapter.getNielsenAppId(CoreVideoInternal.deviceType);
            _this.nielsenSdkInstance = self.NOLBUNDLE.nlsQ(appId, _this.config.appName, options);
        };
        this.initializeSdk();
    }
    _create_class(NielsenSdkApiClient, [
        {
            key: "loadMetadata",
            value: function loadMetadata(metadata) {
                this.nielsenSdkInstance.ggPM(NielsenSdkPlayheadEventTypes.LoadMetadata, metadata);
            }
        },
        {
            key: "trackMetadataEvent",
            value: function trackMetadataEvent(metadata) {
                this.nielsenSdkInstance.ggPM(NielsenSdkPlayheadEventTypes.SendID3, metadata);
            }
        },
        {
            key: "destroy",
            value: function destroy() {}
        }
    ], [
        {
            key: "canUse",
            value: function canUse(deviceType, metaAdapter) {
                var isSupported = metaAdapter.isDeviceSupported(deviceType);
                if (isSupported) {
                    Logger.info("NielsenSdkApiClient can support ".concat(deviceType));
                }
                return isSupported;
            }
        }
    ]);
    return NielsenSdkApiClient;
}();

//# sourceMappingURL=nielsen-sdk-api-client.js.map